module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "files"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.files), function(file) {
    return _c('li', {
      staticClass: "list-group-item row"
    }, [_vm._v("\n        " + _vm._s(file.name) + "\n        "), _c('a', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "href": file.url,
        "target": "_blank"
      }
    }, [_vm._v("Download")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cd41e25!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/files/Files.vue
// module id = 2072
// module chunks = 2